const experienceData = [
    {
      role: "Senior DevOps Engineer",
      company: "UST",
      details: [
        "Implementing and supporting DevOps platform for Boots UK",
        "Deploying microservices in Azure Kubernetes Service",
        "Creating and configuring Helm charts for deployment",
      ],
    },
    {
      role: "DevOps Engineer",
      company: "UST",
      details: [
        "Environment builds",
        "Dockerization of apps",
        "Proxy server setups",
      ],
    },
    {
      role: "System Administrator",
      company: "TechCorp",
      details: [
        "Monitoring and maintaining systems",
        "Configuring and managing network resources",
        "Ensuring server uptime and reliability",
      ],
    },
  ];
  
  export default experienceData;
  